import './AmcPathingHeatmapCell.scss';
import cn from 'classnames';
import { toPrettyNumber, toPrettySpend } from '@src/utils/performance-utils';
import { getSteppedHeatColor, SequentialGreenRamp } from '@src/utils/colors';

export type HeatmapFormat = 'count' | 'money' | 'percent';

const formatHeatmapValue = (value: number, format: HeatmapFormat): string => {
  if (format === 'money') return toPrettySpend(value);
  if (format === 'percent') return `${value.toFixed(3)}%`;
  return toPrettyNumber(value);
};

interface HeatmapCellProps {
  value: number | string;
  // A 0-1 ratio (relative to the column's max, computed in amc-pathing-analysis-utils). Omitted
  // for plain text columns (e.g. the path/campaign name column) that don't heatmap.
  intensity?: number;
  format?: HeatmapFormat;
  align?: 'left' | 'center' | 'right';
}

// Same sequential ramp MetricsTable uses for its own heatmapped cells (see `getHeatMapInfo` in
// metrics-table-utils.ts) — background color is data-driven, so it's an inline style rather than a
// static SCSS class.
export const HeatmapCell = ({ value, intensity, format, align = 'center' }: HeatmapCellProps) => (
  <div
    className={cn('amc-pathing-heatmap-cell', `align-${align}`)}
    style={
      intensity != null
        ? {
            backgroundColor: getSteppedHeatColor(
              { min: 0, max: 1, stops: SequentialGreenRamp },
              intensity
            )
          }
        : undefined
    }
  >
    {format ? formatHeatmapValue(Number(value), format) : value}
  </div>
);
